import { FC, memo, ReactNode } from 'react';
import { useFileInfoDrawerContext } from './context/FileInfoDrawerContext';
import { FileInfoDrawer } from './Drawer';

type Props = {
  title?: string;
  children?: ReactNode;
};

export const FileInfoDrawerContainer: FC<Props> = memo(
  ({ title, children }) => {
    const { open, onClose } = useFileInfoDrawerContext();

    return (
      <FileInfoDrawer open={open} onClose={onClose} title={title}>
        {children}
      </FileInfoDrawer>
    );
  }
);
FileInfoDrawerContainer.displayName = 'FileInfoDrawerContainer';
